
export const SECONDS_PER_QUESTION = 15;